export const molliePos = {
  oAuthFlowHelp: "Authorise my account",
  authSuccess: "Authentication successful",
  installationTitle: "Installation of the Connect Mollie POS App",
  installAction: "Install app",
  molliePos: "Assign Xentral POS Project to Mollie Terminals"
};
